<template>
  <div>
    <!-- 列表栏 -->
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="上传商品" name="first">
          <UpdateShop />
        </el-tab-pane>
        <el-tab-pane label="绝当上传" name="second">绝当上传</el-tab-pane>
        <el-tab-pane label="回收上传" name="third">回收上传</el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import UpdateShop from "@/components/shop/UpdateShop.vue";
export default {
  name: "AddItemData",

  data() {
    return {
      activeName: "first",
    };
  },
  components: {
    UpdateShop,
  },
  methods: {
    handleClick() {},
  },
};
</script>
<style scoped></style>
